
export default {
  name: 'CardBlok',
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  computed: {
    computedClasses() {
      return {
        'outlined': this.blok.outlined,
        'rounded': this.blok.rounded,
        'card-blok': !this.blok.outlined
      }
    },
    href() {
      if (!this.blok.route) return
      return this.blok.route
        .replace('{baseURL}', this.$config.baseURL)
        .replace('{appURL}', this.$config.appURL)
        .replace('{url}', this.$config.url)
    },
    style() {
      return {
        '--card-background': this.blok.backgroundColor,
        '--card-color': this.blok.color,
        '--raw-color': this.rgbColor,
      }
    },
    rgbColor() {
      // check format of color string
      if (this.blok.color.includes('rgba')) {
        // remove rgba() and split values
        const rgba = this.blok.color.replace('rgba(', '').replace(')', '').split(',')
        // return rgb values
        return `${rgba[0]}, ${rgba[1]}, ${rgba[2]}`
      }
      // convert hex to rgba
      const hex = this.blok.color
      const hexToRgb = (hex) => {
        const bigint = parseInt(hex.slice(1), 16)
        const r = (bigint >> 16) & 255
        const g = (bigint >> 8) & 255
        const b = bigint & 255
        return `${r}, ${g}, ${b}`
      }
      return hexToRgb(hex)
    }
  },

}
